import React, { useEffect } from 'react'
import { useState } from "react";

import { makeStyles } from '@material-ui/core/styles';

import LoadingComponent from '../../../../components/Loading';

import { useSelector } from "react-redux";

import {
    selectUsuarioSeleccionado,
} from "../../../../redux/reducer/loginReducer";
import EmptyComponent from '../../../../components/EmptyContent';
// import { deleteInquilino, getAlumnos, inquilinoDelete } from '../../../../services/Alumnos';
import { Box, Button, FormControl, Grid, IconButton, InputLabel, Menu, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import { DataGrid, GridActionsCellItem, GridToolbarDensitySelector, GridToolbarFilterButton} from '@mui/x-data-grid';
import EditIcon from '@material-ui/icons/Edit';
import SyncIcon from '@material-ui/icons/Sync';
import Swal from 'sweetalert2';
import { Link, useHistory } from 'react-router-dom';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import TituloPagina from '../../../../components/Titulos/TituloPagina';
import AddIcon from '@material-ui/icons/Add';
import { getAlumnos, getAlumnosBaja, getAlumnosRegistrados, update_comercial } from '../../../../services/alumnos';
import { Stack } from '@mui/system';
import {sincronizar_formularios, sincronizar_notion, sincronizar_woo_order} from '../../../../services/sincronizar'
import { getComerciales } from '../../../../services/comerciales';
import Moment from 'react-moment';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { BASE_URL_SERVICE } from '../../../../constants';

function escapeRegExp(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }

// import Moment from 'react-moment';

/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: '80px'
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "90vh"
    },
    emptyContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "80vh",
        width: '100%',
        flexDirection: 'column',
        textAlign: 'center'
    },
    emptyImage: {
        width: '100%'
    },
    rootFilter: {
        padding: theme.spacing(0.5, 0.5, 0),
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
      },
    textFieldFilter: {
        [theme.breakpoints.down('xs')]: {
          width: '100%',
        },
        margin: theme.spacing(1, 0.5, 1.5),
        '& .MuiSvgIcon-root': {
          marginRight: theme.spacing(0.5),
        },
        '& .MuiInput-underline:before': {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    enlace: {
      color: theme.palette.link.main,
      textDecoration: 'none'
    }
}));

export default function AlumnosBajaContent() {
    const classes = useStyles();

    const [Alumnos, setAlumnos] = useState([]);
    const [loading, setLoading] = useState(false)
    const [loadingMensaje, setLoadingMensaje] = useState("")

    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });
    const history = useHistory()

    const [selectionModel, setSelectionModel] = React.useState([]);
    const [comercialSeleccionado, setComercialSeleccionado] = React.useState([]);

    const [comerciales, setComerciales] = useState(undefined)

    /* -------------------------------------------------------------------------- */
    /*                                  UseEffect                                 */
    /* -------------------------------------------------------------------------- */
    useEffect(() => {
        setLoading(true)
        setLoadingMensaje("Cargando alumnos")

        const usuario_id = usuarioSeleccionado.id

        getAlumnosBaja({ usuario_id }).then((response) => {

            response && setAlumnos(response.alumnos)
            setLoading(false)
        });

        // getComerciales({usuario_id: usuario_id}).then( (response) => {
        //     response.comerciales && setComerciales(response.comerciales)
        // })
    }, [])

    /* -------------------------------------------------------------------------- */
    /*                           Definicion de columnas                           */
    /* -------------------------------------------------------------------------- */

    
    const columnas = 
    [
      { field: 'id', hide: false, headerName: 'ID' },
      { field: 'nombre', headerName: 'Nombre', minWidth: 150, flex: 1 },
      { field: 'especialidad_nombre', headerName: 'Especialidad',minWidth: 220 },
      { field: 'comunidad_autonoma_nombre', headerName: 'Comunidad',minWidth: 220 },
      { field: 'motivo_baja_nombre', headerName: 'Motivo Baja',minWidth: 220 },
      { field: 'tutor_nombre', headerName: 'Tutor',minWidth: 220 },
      { 
        field: 'es_baja_tutea', 
        headerName: 'Baja tutea',
        minWidth: 220,
        renderCell: (cellValues) => {
          return cellValues.row.es_baja_tutea === '1' ? 'SI' : 'NO'
        }
      },
      {
        'field': 'alumno_desde', 
        'width':120, 
        'headerName': 'Alumno desde', 
        'description': 'Alumno desde',
        type: 'date',
        renderCell: (cellValues) => {
          return (
            
              (cellValues.value !== null && cellValues.value !== "0000-00-00 00:00:00") ?
      
              <Moment format="DD/MM/YYYY">
                {cellValues.value}
              </Moment>
      
              :
      
              <></>
      
            
          );
        } 
      },
      {
        'field': 'fecha_baja', 
        'width':120, 
        'headerName': 'Fecha baja', 
        'description': 'Fecha baja',
        type: 'date',
        renderCell: (cellValues) => {
          return (
            
              (cellValues.value !== null && cellValues.value !== "0000-00-00 00:00:00") ?
      
              <Moment format="DD/MM/YYYY">
                {cellValues.value}
              </Moment>
      
              :
      
              <></>
      
            
          );
        } 
      },
      {
        'field': 'dias_inscritos', 
        'width': 120, 
        'headerName': 'Dias inscritos', 
        'description': 'Dias inscritos',
        'type': "number"
      },
      { field: 'comercial_nombre', headerName: 'Comercial',minWidth: 120 },
      // {
      //   field: 'actions',
      //   type: 'actions',
      //   width: 80,
      //   getActions: (params) => [
      //     <GridActionsCellItem
      //       icon={<EditIcon />}
      //       label="Modificar"
      //       component={Link}
      //       to={`alumnos/detalle/${params.id}`}
      //       showInMenu
      //     />,
      //   ],
      // }
    ]

    /* -------------------------------------------------------------------------- */
    /*                                  Contenido                                 */
    /* -------------------------------------------------------------------------- */
    function QuickSearchToolbar(props) {
        const classes = useStyles();
      
        return (
          <div className={classes.rootFilter}>
            <div>
              <GridToolbarFilterButton />
              <GridToolbarDensitySelector />
            </div>
            <TextField
              variant="standard"
              value={props.value}
              onChange={props.onChange}
              placeholder="Buscar…"
              className={classes.textFieldFilter}
              InputProps={{
                startAdornment: <SearchIcon fontSize="small" />,
                endAdornment: (
                  <IconButton
                    title="Clear"
                    aria-label="Clear"
                    size="small"
                    style={{ visibility: props.value ? 'visible' : 'hidden' }}
                    onClick={props.clearSearch}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />
          </div>
        );
      }
      
      QuickSearchToolbar.propTypes = {
        clearSearch: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.string.isRequired,
      };

    const Contenido = () => {
        const [rows, setRows] = React.useState(Alumnos);
        const [searchText, setSearchText] = React.useState('');
        const requestSearch = (searchValue) => {
          // console.log(searchValue)
          setSearchText(searchValue);
          const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
          // const searchRegex = new RegExp(`.*${searchValue}.*`, 'ig');
          const filteredRows = Alumnos.filter((row) => {
              return Object.keys(row).some((field) => {
                  // console.log(field)
                  // console.log(row)
                  return searchRegex.test(row[field]);
              });
          });
          setRows(filteredRows);
        };

        const handleAlumnoDetalle = (id) => {
          history.push('alumnos/detalle/' + id )
        }
        const [anchorElOpciones, setAnchorElOpciones] = React.useState(null);
        const open = Boolean(anchorElOpciones);
      
        const handleClickOpciones = (event) => {
          setAnchorElOpciones(event.currentTarget);
        };
      
        const handleCloseOpciones = () => {
          setAnchorElOpciones(null);
        };

        const handleExportarTelefonos = () => {
          setAnchorElOpciones(null);
        }
        return (
            rows ?
                <>
                    <Box mt={12} mb={3} mx={2}>
                        <Typography variant="h5" component="h3" gutterBottom display='inline' style={{fontWeight: 500}} >
                            {"Alumnos baja"}
                        </Typography>

                        <IconButton
                          aria-label="more"
                          aria-controls="long-menu"
                          aria-haspopup="true"
                          onClick={handleClickOpciones}
                        >
                          <MoreVertIcon />
                        </IconButton>

                        <Menu
                          id="long-menu"
                          anchorEl={anchorElOpciones}
                          keepMounted
                          open={open}
                          onClose={handleCloseOpciones}
                          
                        >
                        <MenuItem key="opcion1"  onClick={handleExportarTelefonos}>
                          <a 
                            href={`${BASE_URL_SERVICE}alumno/alumnos_exportar_telefonos`} 
                            target='_blank' 
                            style={{textDecoration: 'none'}}>Exportar teléfonos</a>
                        </MenuItem>
                       
                      </Menu>
                    </Box>

                    
    
                    <div style={{ height: 500, width: '100%', padding:"0 15px" }}>
                        <DataGrid 
                            rows={rows} 
                            columns={columnas} 
                            rowHeight={30}
                            components={{ Toolbar: QuickSearchToolbar }}
                            onRowDoubleClick={ (evento ) => handleAlumnoDetalle(evento.id) }
                            componentsProps={{
                                toolbar: {
                                  value: searchText,
                                  onChange: (event) => requestSearch(event.target.value),
                                  clearSearch: () => requestSearch(''),
                                },
                            }}
                        />
                    </div>

                    {/* <Typography variant='caption' style={{marginTop: 10, marginLeft: 16}}>NOTA: Ordenado por fecha de entrada de gasto decreciente</Typography> */}

                </>
                
                :
                <EmptyComponent mensaje="No hay datos para mostrar" />
        )
    }
    
    /* -------------------------------------------------------------------------- */
    /*                                   Return                                   */
    /* -------------------------------------------------------------------------- */
    return (
        <div className={classes.container}>
            {
                (loading ?
                    
                    <LoadingComponent isFullScreen={true} mensaje={loadingMensaje} />
                    
                    :
                    
                    <Contenido />
                )
            }
        </div>
    )
}
